// extracted by mini-css-extract-plugin
export default {"container":"Results_container__FxhKS","title":"Results_title__UYWuX","description":"Results_description__2dXqG"};